import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'addFilterReportDataList',
})
export class AddFilterReportDataList implements PipeTransform {
  transform(fullList: any[], addedtemsList: any[], filterText = ''): any {
    let newList = [];

    fullList.forEach((element) => {
      if (addedtemsList.findIndex((x) => ((x.vault_id === element.id)) || ((x.id === element.id && x.user_id === element.user_id))) == -1) {
        newList.push(element);
      }
    });
    if (filterText?.length) {
      let filterItems = [];
      newList.forEach((element) => {
        if (element?.name?.toLowerCase().includes(filterText.toLowerCase())) {
          filterItems.push(element);
        } else if (element?.vault_name?.toLowerCase().includes(filterText.toLowerCase())) {
          filterItems.push(element);
        } else if (element?.form_name?.toLowerCase().includes(filterText.toLowerCase())) {
          filterItems.push(element);
        }
      });
      return filterItems;
    } else {
      return newList;
    }
  }
}
